import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

const iconPath = (name) => `${CONFIG.assetsDir}/assets/icons/solid-64/${name}`;

const SERVICES = [
  {
    title: 'Our_vision',
    description: 'Our_vision_is_to_become_the_leading_reference_platform_for_enterprise',
    icon: iconPath('ic-chart.svg'),
  },
  {
    title: 'Our_mission',
    description:
      'Our_mission_is_to_empower_businesses_with_reliable_and_integrated_digital_transport_solutions',
    icon: iconPath('ic-report-results.svg'),
  },
  {
    title: 'Reliability',
    description: 'Delivering_consistent_quality_and_dependable_performance_in_every_operation',
    icon: iconPath('ic-real-time.svg'),
  },
  {
    title: 'Operational_Discipline',
    description: 'Managing_transport_processes_through_structured_planning_and_precise_execution',
    icon: iconPath('ic-checklist.svg'),
  },
  {
    title: 'Transparency',
    description: 'Maintaining_clarity_in_contracts_pricing_and_reporting_to_foster_mutual_trust',
    icon: iconPath('ic-transparency.svg'),
  },
  {
    title: 'Innovation',
    description:
      'Continuously_enhancing_our_platform_to_drive_intelligent_transformation_in_logistics',
    icon: iconPath('ic-file-sync.svg'),
  },
  {
    title: 'Empowerment',
    description:
      'Enabling_our_teams_and_clients_to_achieve_their_goals_through_effective_digital_tools_and_integrated_support',
    icon: iconPath('ic-popularity.svg'),
  },
];

// ----------------------------------------------------------------------

export function AboutInnovation({ sx, ...other }) {
  const { t } = useLocale();
  return (
    <Box
      component="section"
      sx={[
        {
          textAlign: 'center',
          pt: { xs: 5, md: 5 },
          pb: { xs: 10, md: 5 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        {/* <Typography variant="h2">Services include</Typography>

        <Typography
          sx={{
            mt: 3,
            mx: 'auto',
            maxWidth: 480,
            color: 'text.secondary',
            mb: { xs: 5, md: 10 },
          }}
        >
          Nunc nonummy metus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis.
        </Typography> */}

        <Box
          sx={{
            display: 'grid',
            columnGap: 10,
            rowGap: { xs: 5, md: 8 },
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
          }}
        >
          {SERVICES.map((item) => (
            <div key={item.title}>
              <SvgColor
                src={item.icon}
                sx={(theme) => ({
                  width: 64,
                  height: 64,
                  background: `linear-gradient(to bottom, ${theme.vars.palette.primary.light}, ${theme.vars.palette.primary.main})`,
                })}
              />

              <Typography component="h6" variant="h5" sx={{ mt: 3, mb: 1 }}>
                {t(item.title)}
              </Typography>

              <Typography sx={{ color: 'text.secondary' }}> {t(item.description)} </Typography>
            </div>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
